import React, { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { middleDotSeparatorMessage } from 'lib/intl/separators'

import BodyText from 'LuxKit/Typography/BodyText'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { formatShortDateRange } from 'tripPlanner/utils'
import moment from 'moment'
import Typography from 'LuxKit/Typography/Typography'
import Group from 'components/utils/Group'

interface Props {
  flightDeal: App.FlightDeal
}

function FlightDealDuration(props: Props) {
  const { flightDeal } = props
  const intl = useIntl()

  const offerDurationLabel = useMemo(() => {
    const separatorChar = intl.formatMessage(middleDotSeparatorMessage)
    const formattedPeriods = flightDeal.travelPeriods.map(period => formatShortDateRange({
      startDate: moment(period.departureDate),
      endDate: moment(period.arrivalDate),
    }))
    return formattedPeriods.join(`  ${separatorChar}  `)
  }, [flightDeal, intl])

  return (<Group direction="vertical">
    <BodyTextBlock
      startIcon={<SolidFireIcon colour="urgency" />}
      variant="small"
      colour="neutral-two"
    >
      <FormattedMessage
        id="A30x18a3R8"
        defaultMessage="<highlight>Limited time flight offer</highlight> Travel between <bold>{offerDurationLabel}.</bold>"
        description="Promotional banner showing limited time flight offer with travel date range"
        values={{
          highlight: (chunks) => <BodyText variant="small" colour="urgency" as="span" weight="bold">{chunks}</BodyText>,
          bold: (chunks) => <Typography as="b" wrap="pre-wrap">{chunks}</Typography>,
          offerDurationLabel,
        }}
      />
    </BodyTextBlock>

    {flightDeal.dealDescription && <BodyTextBlock variant="small" colour="neutral-two">
      {flightDeal.dealDescription}
    </BodyTextBlock>}
  </Group>)
}

export default FlightDealDuration
